Object.defineProperty(exports,"__esModule",{value:true});var isDisabled=function isDisabled(props){return props.disabled||props['aria-disabled'];};exports.default=isDisabled;


//////////////////
// WEBPACK FOOTER
// ./~/react-native-web/dist/modules/AccessibilityUtil/isDisabled.js
// module id = 159
// module chunks = 0